<template>
  <div>
    Logout complete, you can close this window.
  </div>
</template>

<script>
  export default {
    name: 'CognitoLogoutCallback',
    created() {
      this.$store.commit('hideHeaderAndFooter')
    },
    mounted() {
      window.close()
    }
  }
</script>

<style lang="scss" scoped>
  div {
    text-align: center;
    padding: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/CognitoLogoutCallback.vue